import React from "react";
import { CommonConstants } from "utils/constants";

function useSuccessAnimation(reloadHandler?: () => void) {
  const [showSuccess, setShowSuccess] = React.useState<boolean>(false);

  const onSuccess = () => {
    setShowSuccess(true);
    if (reloadHandler) reloadHandler();

    setTimeout(() => {
      setShowSuccess(false);
    }, CommonConstants.SuccessIndicatorDurationMs);
  };

  return { onSuccess, showSuccess };
}

export default useSuccessAnimation;
